import React from 'react'

import { CardContainer } from './cardDetail.style'

const CardDetail = ({ src, detail }) => {
  const styleLearn = { height: '150px' }

  return (
    <CardContainer>
      <div className='icon-learn'>
        <img src={src} alt='learngood icon' style={styleLearn}loading="lazy" />
      </div>
      <p>{detail}</p>
    </CardContainer>
  )
}

export default CardDetail
